import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, CardContent, Stack, type Theme } from "@mui/material";
import { Card, Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

import { DocumentStatusPill } from "../components/StatusPill";

interface DocumentDetailsBannerWithActionProps {
  variant: WorkerRequirementStatus.MISSING | WorkerRequirementStatus.EXPIRING;
  expiryDate?: Date;
  header: string;
  subHeader?: string;
  button: ReactNode;
  illustration?: ReactNode;
}

export function DocumentDetailsBannerWithAction(props: DocumentDetailsBannerWithActionProps) {
  const { variant, expiryDate, button, illustration, header, subHeader } = props;

  function getCardBackground(theme: Theme) {
    return variant === WorkerRequirementStatus.EXPIRING
      ? theme.palette.documents?.warning.gradient
      : theme.palette.documents?.neutral.gradient;
  }

  return (
    <Card
      variant="tertiary"
      sx={(theme) => ({
        flexShrink: 0,
        background: getCardBackground(theme),
        minHeight: theme.size?.documents.bannerWithAction.minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      <CardContent sx={{ paddingX: 7, width: "100%" }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Stack spacing={5} alignItems="center">
            {variant === WorkerRequirementStatus.EXPIRING && isDefined(expiryDate) && (
              <Box alignSelf="flex-start">
                <DocumentStatusPill size="small" variant="expiring_soon" expiry={expiryDate} />
              </Box>
            )}
            <Stack spacing={2}>
              <Text semibold variant="h5">
                {header}
              </Text>
              {isDefined(subHeader) && (
                <Text semibold variant="body2">
                  {subHeader}
                </Text>
              )}
            </Stack>
            {button}
          </Stack>
          {isDefined(illustration) && illustration}
        </Stack>
      </CardContent>
    </Card>
  );
}
